import Axios from 'axios'

let axios = Axios.create()

axios.interceptors.response.use((response) => {

    if( response instanceof Error ){

        return Promise.reject(response.message)

    }else{

        return Promise.resolve(response.data)

    }
    
})

export default {
    notifications: {
        registerPushToken: (data) => axios.post(`/api/register-push-token`, data),
        deactivatePushToken: (data) => axios.post(`/api/deactivate-push-token`, data)
    }
}



// WEBPACK FOOTER //
// ./frontEnd/notifications/services/services.js